
import React, {useState} from "react";
import {Link, useHistory, useLocation} from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import Breadcrumb from 'layouts/main/Breadcrumb';
import UIInput from 'components/input/input';
//import UIInputFile from 'components/input/inputFile';
import Button from 'components/buttons/';
import UIDatePicker from "components/datepicker";
import useToggleState from 'components/hooks/useToggleState';
import { Tooltip } from 'react-tooltip';
import CommonUtil from "../../../../utils/CommonUtil";
import StringUtil from "../../../../utils/StringUtil";
import codeDataStore from "../../../../common/codedata/store/CodeDataStore";
import UISelect from "../../../../components/selectbox/UISelect";
import PageLoading from "../../../../components/loading";
import UIUtils from "../../../../utils/UIUtils";
import UI from "../../../../components/UI";
import TbComFile from "domain/main/com/file/TbComFile";
import TbComFileMapngDetail from "domain/main/com/file/mapng/TbComFileMapngDetail";
import userStore from "../../../../common/user/store/UserStore";

function ContentsContainer() {
	const [corpInfo, setCorpInfo] = useState<any>({});
	const location = useLocation();
	const receivedData = (location.state as any)?.data;
	const history = useHistory();

	const [bizNo ,setBizNo] = useState('');
	const [bizCd ,setBizCd] = useState('');
	const [donNo ,setDonNo] = useState('');
	const [fileId, setFileId] = useState('');


	//밑에 담당자 정보
	const [corpNm,setCorpNm] = useState(''); //과제명
	const [corpRegNo,setCorpRegNo] = useState(''); //사업자번호
	const [personNm,setPersonNm] = useState(''); //이름
	const [posiNm,setPosiNm] = useState(''); //직급
	const [deptNm,setDeptNm] = useState(''); //부서명
	const [emailAdres,setEmailAdres] = useState(''); //이메일
	const [ofcTelNo,setOfcTelNo] = useState(''); //전화번호
	const [personId, setPersonId] = useState('');

	const [DonReqDate,setDonReqDate] = useState(new Date());
	const [type,setType] = useState('M');
	const [donReqAmt,setDonReqAmt] = useState(0);

	const [loadFinish,setLoadFinish] = useState(false);
	const serverUrl = 'http://dev.fund.win-win.or.kr/';


	//파일정보 선언
	const [reqFileNm, setReqFileNm] = useState('');

	const [reqFileValue] = useState(new TbComFile());
	const [otherFiles] = useState(new TbComFile());

	const [uploadComp, setUploadComp] = useState(false);
	const [fileInfoList, setFileInfoList] = React.useState<any[]>([]);
	const [fileInfoListPop, setFileInfoListPop] = React.useState<any[]>([]);

	//파일업로드
	const [uploadId, setUploadId] = React.useState("");
	const [REC,setREC] = useState<any>([]);
	const [funPurUseCd,setFunPurUseCd] = useState(''); //기부금 사용용도


	//파일업로드
    const onCreationComplete = function (uploadID: string) {
        setUploadId(uploadID);
    }

	//파일업로드 완료
	const onUploadComplete = () => {
        const dataArray = window["RAONKUPLOAD"].GetListInfo('array', uploadId);
        const arrayNew = dataArray.newFile;
        const arrayDel = dataArray.deleteFile;
	    console.log("arrayNew " ,JSON.stringify(arrayNew));

		let fileInfos : {
			FILE_DETAIL_ID:string;
			ORGINL_FILE_NM:string;
			STRE_FILE_NM:string;
			FILE_SIZE:number;
			STRE_PATH:string;
			FILE_EXTSN:string;
			FILE_GB:string;
			FILE_STATUS:string;
		}[] = [];

		let fileInfo : {
			FILE_DETAIL_ID:string;
			ORGINL_FILE_NM:string;
			STRE_FILE_NM:string;
			FILE_SIZE:number;
			STRE_PATH:string;
			FILE_EXTSN:string;
			FILE_GB:string;
			FILE_STATUS:string;
		};

		//파일등록 정보
		arrayNew?.map((item, index) => {
			if(item.status =="complete"){
				fileInfo = {
					FILE_DETAIL_ID:item.uniqKey,
					ORGINL_FILE_NM:item.originalName,
					STRE_FILE_NM:item.uploadName,
					FILE_SIZE:item.size,
					STRE_PATH:"/" + item.uploadPath.split("/").reverse().slice(1, 3).reverse().join("/") ,
					FILE_EXTSN:item.extension,
					FILE_GB:"",
					FILE_STATUS:"ADD"
				}

				fileInfos.push(fileInfo);
			}

			console.log("fileInfos : "+JSON.stringify(fileInfos));
		})

		//파일등록 정보
		arrayDel?.forEach((item, index) => {
			fileInfo = {
				FILE_DETAIL_ID:item.uniqKey,
				ORGINL_FILE_NM:item.originalName,
				STRE_FILE_NM:item.uploadName,
				FILE_SIZE:item.size,
				STRE_PATH:"/" + item.uploadPath.split("/").reverse().slice(1, 3).reverse().join("/") ,
				FILE_EXTSN:item.extension,
				FILE_GB:"",
				FILE_STATUS:"DEL"
			}

			fileInfos.push(fileInfo);

		})

		setFileInfoList(fileInfos);
		setUploadComp(true);
    }

	async function onFileUpload()  {
		if(uploadId){
			await window["RAONKUPLOAD"].Transfer(uploadId);
		}
	}

	React.useEffect(() => {
		if(uploadComp){
			onClickSave(uploadComp);
		}
	},[uploadComp])

	function moveBack(){
		let dataToSend = {
			"vDON_NO": receivedData.vDON_NO,
			"vBIZ_NO": receivedData.vBIZ_NO,
			"vBIZ_CD": receivedData.vBIZ_CD
		};

		// 다른 페이지로 이동하면서 데이터 전달
		history.push({
			pathname: './usr_2004',
			state: { data: dataToSend }
		});
	}


	const alertModal = async (chk) => {
		const value = await UIUtils.alert(<>
			<div className='ta-center'> 필수 입력이 완료되지 않았습니다.<br/>
			다시 확인 후 저장해 주세요.<br/>
			{(chk=="" || chk == null ? "" : chk)}
			</div>
		</>);
	}


	const isChkValid = (chk) => {

		if(!DonReqDate){
			alertModal("[출연 신청일]");
			return false;
		}
		
		if(bizCd == '' || bizCd == '선택'){
			alertModal("[출연 사업]");
			return false;
		}
		
		if(donReqAmt == 0){
			alertModal("[출연 금액]");
			return false;
		}
		
		if(corpInfo.ELEC_APPR_YN =='N' && reqFileNm == ''){
			alertModal("[출연신청서]");
			return false;
		}

		if(personNm == ''){
			alertModal("담당자");
			return false;
		}
		
		
		onClickSave(chk);


		return false;

	}


	async function onClickSave(chk) {

		if(chk){
			setUploadComp(false);

			let year = DonReqDate.getFullYear();
			let month = DonReqDate.getMonth()+1;
			let day = DonReqDate.getDate();

			let donReqDateText = year+'-'+dateLpad(month)+'-'+dateLpad(day);

			if(reqFileValue.tbComFileMapngDetailList.length == 1 && fileInfoListPop.filter(a => a.FILE_GB == 'REQ').length == 1){
				let fileInfo : {
					FILE_DETAIL_ID:string | undefined;
					ORGINL_FILE_NM:string | undefined;
					STRE_FILE_NM:string | undefined;
					FILE_SIZE:number | undefined;
					STRE_PATH:string | undefined;
					FILE_EXTSN:string | undefined;
					FILE_GB:string | undefined;
					FILE_STATUS:string | undefined;
				};
				let info = reqFileValue.tbComFileMapngDetailList[0];
				// @ts-ignore
				let fileDetailId = info.fileDetailId;
				// @ts-ignore
				let orginlFileNm = info.orginlFileNm;
				// @ts-ignore
				let streFileNm = info.streFileNm;
				// @ts-ignore
				let fileSize = info.fileSize;
				// @ts-ignore
				let strePath = info.strePath;
				// @ts-ignore
				let fileExtsn = info.fileExtsn;

				//파일등록 정보
				fileInfo = {
					FILE_DETAIL_ID:fileDetailId,
					ORGINL_FILE_NM:orginlFileNm,
					STRE_FILE_NM:streFileNm,
					FILE_SIZE:fileSize,
					STRE_PATH: strePath,
					FILE_EXTSN:fileExtsn,
					FILE_GB:"REQ",
					FILE_STATUS:"DEL"
				}

				fileInfoList.push(fileInfo);
			}


			let param = {
				"DON_NO": donNo,
				"DON_CONT_DIV_CD": type,
				"DON_REQ_DATE": donReqDateText,
				"BIZ_CD" : bizCd,
				"DON_REQ_AMT" : donReqAmt,
				"PERSON_NM" : personNm,
				"POSI_NM" : posiNm,
				"DEPT_NM" : deptNm,
				"EMAIL_ADRES" : emailAdres,
				"OFC_TEL_NO" : ofcTelNo,
				"FILE_ID" : fileId,
				"PERSON_ID" : personId,
				"FUN_PUR_USE_CD" : funPurUseCd,
				FILE_INFO_LIST:fileInfoListPop.concat(fileInfoList)
			};


			//바로 저장 진행
			const response:any = await CommonUtil.execute({
				url:'usr_2006',
				data: param
			}).then((response: any) => {
				if(response){
					UIUtils.alert('저장되었습니다.').then();

					moveBack();
				}
			}).catch(err => {
				CommonUtil.showAxiosError(err);
				return;
			});
		}else{
			if(await UIUtils.confirm('수정 하시겠습니까?')){
				onFileUpload();
			}
		}

	};

	async function initCall(){

		//console.log("bizNo " +receivedData.vBIZ_NO);
		//let bizNo = receivedData.vBIZ_NO;

		let param = {
			"DON_NO": receivedData.vDON_NO,
			"BIZ_NO": receivedData.vBIZ_NO,
			"BIZ_CD": receivedData.vBIZ_CD
		};

		const response:any = await CommonUtil.execute({
			url:'usr_2004',
			data: param
		})

		const result = response;
		console.log(result)
		setCorpInfo(result);
		setDonReqAmt(Number(result.DON_REQ_AMT));
		setDonReqDate(new Date(result.DON_REQ_DATE));
		setType(result.DON_CONT_DIV_CD)
		setFileId(result.FILE_ID);
		setFunPurUseCd(result.FUN_PUR_USE_CD);

		// REQ - 신청서, PLAN - 계획서, 수행기관 사업자 등록증 - BIZ
		otherFiles.setTbComFileMapngDetailList([]);
		reqFileValue.setTbComFileMapngDetailList([]);
		let fileList = result.FILE_INFO;
		for(let i = 0; i < fileList.length; i++){
			if(fileList[i].FILE_GB == 'REQ'){
				let reqFileInfo = fileList[i];

				//파일등록 정보
				const fileDetail = new TbComFileMapngDetail();
				fileDetail.setDwldId(reqFileInfo.DWLD_ID);
				fileDetail.setFileDetailId(reqFileInfo.FILE_DETAIL_ID);
				fileDetail.setFilePolicy(reqFileInfo.FILE_POLICY);
				fileDetail.setFileRpstr(reqFileInfo.FILE_RPSTR);
				fileDetail.setStrePath(reqFileInfo.STRE_PATH);
				fileDetail.setStreFileNm(reqFileInfo.STRE_FILE_NM);
				fileDetail.setOrginlFileNm(reqFileInfo.ORGINL_FILE_NM);
				fileDetail.setFileExtsn(reqFileInfo.FILE_EXTSN);
				fileDetail.setFileSize(reqFileInfo.FILE_SIZE);
				fileDetail.setRegistPsnNm(reqFileInfo.REGIST_PSN_NM);
				fileDetail.setRegistDt(reqFileInfo.REGIST_DT);
				reqFileValue.putTbComFileMapngDetailList(fileDetail);
				setReqFileNm(reqFileInfo.ORGINL_FILE_NM);

			}else{
				let otherFileInfo = fileList[i];

				//파일등록 정보
				const fileDetail = new TbComFileMapngDetail();
				fileDetail.setDwldId(otherFileInfo.DWLD_ID);
				fileDetail.setFileDetailId(otherFileInfo.FILE_DETAIL_ID);
				fileDetail.setFilePolicy(otherFileInfo.FILE_POLICY);
				fileDetail.setFileRpstr(otherFileInfo.FILE_RPSTR);
				fileDetail.setStrePath(otherFileInfo.STRE_PATH);
				fileDetail.setStreFileNm(otherFileInfo.STRE_FILE_NM);
				fileDetail.setOrginlFileNm(otherFileInfo.ORGINL_FILE_NM);
				fileDetail.setFileExtsn(otherFileInfo.FILE_EXTSN);
				fileDetail.setFileSize(otherFileInfo.FILE_SIZE);
				fileDetail.setRegistPsnNm(otherFileInfo.REGIST_PSN_NM);
				fileDetail.setRegistDt(otherFileInfo.REGIST_DT);
				otherFiles.putTbComFileMapngDetailList(fileDetail);
			}
		}

		setPersonId(result.REG_USERID);

		let param2 = {};

		const response1:any = await CommonUtil.execute({
			url:'TbComPersonEntityMapper_select_bizno',
			data: param2
		})

		const result1 = response1;
		console.log(result1)
		if(result1.REC.length != 0){
			setREC(result1.REC);
//			const personId = userStore.userModel?.getPersonId();
//			console.log("personId : " + personId)
			let info = result1.REC.filter(a => a.PERSON_ID == result.REG_USERID)[0]
			if(info.length == 0){
				info = result1.REC[0];
			}

			setPersonId(info.PERSON_ID);
			setCorpNm(info.CORP_NM);
			setBizNo(info.BIZ_NO);
			setCorpRegNo(info.CORP_REG_NO);
			setPersonNm(info.PERSON_NM);
			setPosiNm(info.POSI_NM);
			setDeptNm(info.DEPT_NM);
			setEmailAdres(info.EMAIL_ADRES);
			setOfcTelNo(info.OFC_TEL_NO);
		}

		// @ts-ignore
		if(typeof corpInfo == 'undefined'){
			alert('data is not loaded!!!')
			return;
		}

		setLoadFinish(true);
	};

	function dateLpad(num){
		if(num.toString().length == 1){
			num = "0"+num;
		}

		return num;
	}


	function dateToStr(dateText) {

		if(dateText == null) return '';

		if(/^(-?)[0-9]+$/.test(dateText)){
			dateText = Number(dateText);
		}
		let date = new Date(dateText);
		let week = new Array('일', '월', '화', '수', '목', '금', '토');


		let year = date.getFullYear();
		let month = date.getMonth()+1;
		let day = date.getDate();
		let dayName = week[date.getDay()];

		return year+'-'+dateLpad(month)+'-'+dateLpad(day)+'('+dayName+')';
	}

	const handleSelect = (e) => {
		if(e.target.name === 'type'){
			setType(e.target.value);
		}
	};

	React.useEffect(() => {
		codeDataStore.read(
			"cfms.portalBizCdList", "[FPUC]"
		).then(() => {
			console.log("cfms.portalBizCdList", codeDataStore.get("cfms.portalBizCdList"))
		});

		//넘어온 파라미터 바인딩
		if(receivedData !==undefined){
			setBizNo(StringUtil.defaultString(receivedData.vBIZ_NO));
			setBizCd(StringUtil.defaultString(receivedData.vBIZ_CD));
			setDonNo(StringUtil.defaultString(receivedData.vDON_NO));
			initCall();

		}
	}, [])//effect


	/**
   * 출연신청서
   */
	const reqModal = () => {
		UIUtils.openFileUploadPopup({
			title: "출연신청서",
			buttonTitle: "등록",
			attrs: {
				MaxTotalFileCount: "1",
				ExtensionAllowOrLimit: "1",
			},
			valueChanged: async data => {
				console.log("fileId uploadId : "+ uploadId);

				// @ts-ignore
				if(data != undefined && data.tbComFileMapngDetailList.length != 0){
					const dataArray = window["RAONKUPLOAD"].GetListInfo('array', uploadId);
					const arrayNew = dataArray.newFile;
					const arrayDel = dataArray.deleteFile;
					console.log("arrayNew", JSON.stringify(arrayNew));

					let fileInfos : {
						FILE_DETAIL_ID:string | undefined;
						ORGINL_FILE_NM:string | undefined;
						STRE_FILE_NM:string | undefined;
						FILE_SIZE:number | undefined;
						STRE_PATH:string | undefined;
						FILE_EXTSN:string | undefined;
						FILE_GB:string | undefined;
						FILE_STATUS:string | undefined;
					}[] = [];

					let fileInfo : {
						FILE_DETAIL_ID:string | undefined;
						ORGINL_FILE_NM:string | undefined;
						STRE_FILE_NM:string | undefined;
						FILE_SIZE:number | undefined;
						STRE_PATH:string | undefined;
						FILE_EXTSN:string | undefined;
						FILE_GB:string | undefined;
						FILE_STATUS:string | undefined;
					};



					// @ts-ignore
					let item = data.tbComFileMapngDetailList[0];

					// @ts-ignore
					let uniqKey = item.uniqKey;
					// @ts-ignore
					let orginlFileNm = item.orginlFileNm;
					// @ts-ignore
					let streFileNm = item.streFileNm;
					// @ts-ignore
					let fileSize = item.fileSize;
					// @ts-ignore
					let strePath = item.strePath;
					// @ts-ignore
					let fileExtsn = item.fileExtsn;

					//파일등록 정보
					fileInfo = {
						FILE_DETAIL_ID:uniqKey,
						ORGINL_FILE_NM:orginlFileNm,
						STRE_FILE_NM:streFileNm,
						FILE_SIZE:fileSize,
						STRE_PATH: strePath,
						FILE_EXTSN:fileExtsn,
						FILE_GB:'REQ',
						FILE_STATUS:"ADD"
					}

					// @ts-ignore
					setReqFileNm(orginlFileNm)

					fileInfos.push(fileInfo);
					setFileInfoListPop(fileInfos);
				}

			}
		})
	}

	async function fileDelete(type){
		// @ts-ignore
		let item;
		if(type == 'REQ' && reqFileValue.tbComFileMapngDetailList.length != 0){
			item = reqFileValue.tbComFileMapngDetailList[0];
		}

		if(item == undefined){
			UIUtils.alert('삭제 할 파일이 없습니다.').then();
			return;
		}

		if(await UIUtils.confirm('삭제하시겠습니까?')){

			setReqFileNm('')

			let fileInfos : {
				FILE_DETAIL_ID:string | undefined;
				ORGINL_FILE_NM:string | undefined;
				STRE_FILE_NM:string | undefined;
				FILE_SIZE:number | undefined;
				STRE_PATH:string | undefined;
				FILE_EXTSN:string | undefined;
				FILE_GB:string | undefined;
				FILE_STATUS:string | undefined;
			}[] = [];

			let fileInfo : {
				FILE_DETAIL_ID:string | undefined;
				ORGINL_FILE_NM:string | undefined;
				STRE_FILE_NM:string | undefined;
				FILE_SIZE:number | undefined;
				STRE_PATH:string | undefined;
				FILE_EXTSN:string | undefined;
				FILE_GB:string | undefined;
				FILE_STATUS:string | undefined;
			};



			// @ts-ignore
			let uniqKey = item.fileDetailId;
			// @ts-ignore
			let orginlFileNm = item.orginlFileNm;
			// @ts-ignore
			let streFileNm = item.streFileNm;
			// @ts-ignore
			let fileSize = item.fileSize;
			// @ts-ignore
			let strePath = item.strePath;
			// @ts-ignore
			let fileExtsn = item.fileExtsn;

			//파일등록 정보
			fileInfo = {
				FILE_DETAIL_ID:uniqKey,
				ORGINL_FILE_NM:orginlFileNm,
				STRE_FILE_NM:streFileNm,
				FILE_SIZE:fileSize,
				STRE_PATH: strePath,
				FILE_EXTSN:fileExtsn,
				FILE_GB:type,
				FILE_STATUS:"DEL"
			}

			fileInfos.push(fileInfo);
			let newList = [...fileInfoListPop];
			setFileInfoListPop(newList.concat(fileInfos));
			UIUtils.alert('정상 처리 되었습니다 저장시 파일이 삭제 됩니다.').then();
		}

	}

	function getOzReportReq(){

		UIUtils.openOZReportViewerPopup({
			title: "출연신청서",
			reportName: "don_req",
			parameter: {
				"odi.odinames": "don_req",
				"odi.don_req.pcount": "1",
				"odi.don_req.args1": "don_no=" + donNo,
				"information.debug":"true", // 콘솔정보(Ctrl+Z) 표시 여부
				// "toolbar.first":"true", // 첫페이지 이동 아이콘 표시
				// "toolbar.last":"true", // 마지막페이지 이동 아이콘 표시

				"pdf.fontembedding":"true", // PDF 폰트포함 (글꼴 깨지는것 방지)
				"pdf.fontembedding_subset":"true", // 폰트의 서브셋을 저장할지 여부

				"export.format":"pdf", // 저장포맷
				"export.filename": "출연신청서" + ".pdf", // 파일명
				"export.mode":"silent", // 설정창 보여줄지 여부

				"viewer.pagedisplay":"continuous", // 페이지 표시 옵션
				"viewer.viewmode":"normal", // 보고서 보기 모드
				"viewer.zoom": "90"
			},
			onClose: () => {
				console.log("Report Viewer Close");
			}
		})
	}


	const downloadButtonClickHandler = () => {
		CommonUtil.downloadTemplateFile("don_req.hwp", "양식_대중소기업_상생협력기금_출연신청서.hwp");
	}
	
	
	const manageSelect = (e) => {
		let selectManage = REC.filter(a => a.PERSON_ID == e.target.value);

		if(selectManage.length != 0){
			let info = selectManage[0];
			setPersonId(info.PERSON_ID)
			setCorpNm(info.CORP_NM);
			setBizNo(info.BIZ_NO);
			setCorpRegNo(info.CORP_REG_NO);
			setPersonNm(info.PERSON_NM);
			setPosiNm(info.POSI_NM);
			setDeptNm(info.DEPT_NM);
			setEmailAdres(info.EMAIL_ADRES);
			setOfcTelNo(info.OFC_TEL_NO);
		}
	
	};
	
	if(!loadFinish)
		return (
			<PageLoading />
		)
	else
	return (
		<PageContainer>
			<LayoutAside />
			<div className='fww-con'>
				<Breadcrumb gnbIdx={1} lnbIdx={1}/>
				<main className="fww-main">
					<h1 className="tx tx-hd2">출연내용 수정</h1>
					<section className="fund-section">
						<h3 className="section-title mb15">출연 신청 정보</h3>
						<form className="fo fo-col2" name="" action="" method="">
							<div className="inner">
								<div className="fo-item">
									<p className="fo-key">출연번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={corpInfo.DON_NO_FMT} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">출연상태</p>
									<div className="fo-value">
										{corpInfo.DON_PROC_STS_CD  == 'A' ? ( <label className="badge badge-22 blue">신청</label> ) : '' }
										{corpInfo.DON_PROC_STS_CD  == 'E' ? ( <label className="badge badge-22 green">입금확인</label>) : '' }
										{corpInfo.DON_PROC_STS_CD  == 'G' ? ( <label className="badge badge-22 gray">수납완료</label> ) : '' }
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">출연 신청일</p>
									<div className="fo-value">
										<div className="w215">
											<UIDatePicker
												value={DonReqDate}
												valueChanged={(value) => {setDonReqDate(value);}}
												minDate={new Date()}
											/>
										</div>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">기부내용</p>
									<div className="fo-value">
										<div className="sl sl-md w100p">
											<select name={'type'} value={type} onChange={(e) => handleSelect(e)}>
												<option value={'M'}>금전</option>
												<option value={'C'}>현물</option>
											</select>
										</div>
									</div>
								</div>
								<div className="fo-item req">
									<p className="fo-key">출연 사업</p>
									<div className="fo-value">
										<div className="sl sl-md w100p">
											<UISelect
												value={bizCd}
												valueChanged={(value) => setBizCd(String(value))}
												codeData={codeDataStore.get("cfms.portalBizCdList")}
												firstName={"sel"}
											/>
										</div>
									</div>
								</div>
								<div className="fo-item req">
									<p className="fo-key">출연 금액</p>
									<div className="fo-value">
										<div className="hz-root hz-gap5 w100p">
											<div className="tf-unit hz-item hz-fg">
												<UIInput className={'tf tf-md ta-right'} value={StringUtil.formatNumber(Number(donReqAmt)) || "0"} valueChanged={(value) => { let tmpVal = value.replace(/[^0-9]/g, ""); setDonReqAmt(tmpVal) }} placeholder={''} />
												<span className="u">원</span>
											</div>
											<div className="hz-item tx-msg"><span className="fc-pri">({StringUtil.isNotEmpty(donReqAmt + "")
															? StringUtil.numKorPattern(donReqAmt) + " 원"
															: "원"})</span></div>
										</div>
									</div>
								</div>
								<div className="fo-item req">
									<p className="fo-key">기금사용용도</p>
									<div className="fo-value">
										<div className="sl sl-md w100p">
											<UISelect
												value={funPurUseCd}
												valueChanged={(value) => setFunPurUseCd(String(value))}
												codeData={codeDataStore.get("[FPUC]")}
//												firstName={"sel"}
											/>
										</div>
									</div>
								</div>
							</div>
						</form>
					</section>
					<section className="fund-section">
						<div className="hz-root hz-sb mb15">
							<h3 className="section-title hz-item">첨부파일</h3>
						</div>
						<form className="fo fo-col2" name="" action="" method="">
							<div className="inner">
								{ corpInfo.ELEC_APPR_YN =='Y' &&
									<div className="fo-item fo-m-1-3">
										<div className="fo-key">
											<span>출연신청서</span>&nbsp;
											<button type="button" className="button-tooltip" data-tooltip-id="tooltip">툴팁</button>
											<Tooltip
												id="tooltip"
												disableStyleInjection={true}
												place={"bottom-start"}
												className="tooltip-conts"
												//openOnClick
											>
												<div className="msg">
													<h6 className="tooltip-title">출연 신청 시 첨부 서류</h6>
													<ul className="list-group">
														<li>서면 : 출연신청서(서면) 클릭하여 출연신청서 출력 후 직인을 찍고 스캔하여 수정버튼을 클릭하여 이동한 화면에서 출연신청(첨부문서)에 등록 후 저장하셔야 합니다.</li>
														<li>전자인증 : 기업용 공인인증서를 이용하여 출연신청서(전자인증)을 클릭하여 인증을 완료하시면 됩니다. 첨부 문서는 없습니다.</li>
													</ul>
												</div>
											</Tooltip>
										</div>

										<div className="fo-value">

												<div className="fund-form-group">
													<div className="fund-form-items">
														<p className="tx-msg">출연신청서 전자인증을 완료하였습니다.</p>
													</div>
													{/*<Button color='pri-o' size="md" onClick={() => getOzReportReq()}>미리보기</Button>*/}
												</div>

										</div>
									</div>
								}
								{ corpInfo.ELEC_APPR_YN =='N' &&
									<div className="fo-item fo-m-1-3">
										<div className="fo-key">
											<span>출연신청서</span>&nbsp;
											<button type="button" className="button-tooltip" data-tooltip-id="tooltip">툴팁</button>
											<Tooltip
												id="tooltip"
												disableStyleInjection={true}
												place={"bottom-start"}
												className="tooltip-conts"
												//openOnClick
											>
												<div className="msg">
													<h6 className="tooltip-title">출연 신청 시 첨부 서류</h6>
													<ul className="list-group">
														<li>서면 : 출연신청서(서면) 클릭하여 출연신청서 출력 후 직인을 찍고 스캔하여 수정버튼을 클릭하여 이동한 화면에서 출연신청(첨부문서)에 등록 후 저장하셔야 합니다.</li>
														<li>전자인증 : 기업용 공인인증서를 이용하여 출연신청서(전자인증)을 클릭하여 인증을 완료하시면 됩니다. 첨부 문서는 없습니다.</li>
													</ul>
												</div>
											</Tooltip>
										</div>
										<div className="fo-value">
											<div className="fund-form-group">
												<div className="fund-form-items mr30">
													<div className="hz-root hz-gap8 w100p">
														<UIInput className={'tf tf-md hz-item grow'} value={reqFileNm} placeholder={'파일을 첨부해 주세요.'} />
														<div className="hz-root hz-gap8 ">
															<Button color='pri-o2' size="md" onClick={reqModal}>찾기</Button>
															<Button color='gray-o' size="md" onClick={() => fileDelete('REQ')}>삭제</Button>
														</div>
													</div>
												</div>

												<Button color='gray-o' size="md" onClick={downloadButtonClickHandler}>양식 다운로드</Button>
											</div>
										</div>
									</div>
								}
							</div>
						</form>
						<p className="tx-msg mt10 mb18"><span className="fc-pri">※ 항목 외 기타 파일들은 아래 파일 첨부를 이용해 주세요.</span></p>
						<UI.FileUpload
							onCreationComplete={onCreationComplete}
							onUploadComplete={onUploadComplete}
							value={otherFiles}
							attrs={{
								MaxTotalFileCount: "1",
								ExtensionAllowOrLimit: "1",
								Width:"100%",
								ImgPreView: "1",
								Views: "thumbs"
							}}
						/>
					</section>
					<section className="fund-section">
						<h3 className="section-title mb15">기업 정보</h3>
						<form className="fo fo-col2" name="" action="" method="">
							<div className="inner">
								<div className="fo-item">
									<p className="fo-key">기업명</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={corpNm} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">법인사업자번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={corpRegNo} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">사업자번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={StringUtil.bizCrpFormat(bizNo)} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item req">
									<p className="fo-key">담당자</p>
									<div className="fo-value">
										{/*<UIInput className={'tf tf-md w100p'} value={personNm} valueChanged={(value) => {setPersonNm(value)}} placeholder={''} />*/}
										<div className="sl sl-md w120">
											<select name="personId" id="personId" value={personId} onChange={(manageSelect)}>
												{REC.map((info, idx) => (
													<option key={info.PERSON_ID} value={info.PERSON_ID}>{info.PERSON_NM}</option>
												))}
											</select>
										</div>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">직급</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={posiNm} valueChanged={(value) => {setPosiNm(value)}} placeholder={''} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">부서</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={deptNm} valueChanged={(value) => {setDeptNm(value)}} placeholder={''} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">이메일</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={emailAdres} valueChanged={(value) => {setEmailAdres(value)}} placeholder={''} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">전화번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={StringUtil.telephoneFormat(ofcTelNo)} valueChanged={(value) => {setOfcTelNo(value)}} placeholder={''} />
									</div>
								</div>
							</div>
						</form>
					</section>
					<div className="hz-root hz-right hz-gap10 mt30">
						<Button color="gray-o" size="md" onClick={() => moveBack()}>취소</Button>
						<Button color="pri" size="md" onClick={() => isChkValid(false)}>저장</Button>
						<Button color="gray-o" size="md" href="/main/usr_2000/usr_2002">목록</Button>
					</div>
				</main>
			</div>
		</PageContainer>
	);
}
export default ContentsContainer;